module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAACCAYAAABVGIzMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAeSURBVHgBrcABAQAABMCwk0T/UjS5ECzUBoqbSZ4sfdYE4Km+UvMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/ico_minus.png
// module id = VVcf
// module chunks = 0